import { ContentfulLivePreview } from '@contentful/live-preview';

export function inspectorMode(entryId?: string, fieldId?: string) {
  return ContentfulLivePreview.getProps({ entryId: `${entryId}`, fieldId: `${fieldId}` });
}
